(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.sizeGuideInit) return;
  window.sizeGuideInit = true;

  var sizeData = [
    { in: 36, cm: 90 },
    { in: 38, cm: 95 },
    { in: 40, cm: 100 },
    { in: 42, cm: 105 },
    { in: 44, cm: 110 },
    { in: 46, cm: 115 },
    { in: 48, cm: 120 },
    { in: 50, cm: 125 },
    { in: 52, cm: 130 },
    { in: 54, cm: 135 },
    { in: 56, cm: 140 },
    { in: 58, cm: 145 },
    { in: 60, cm: 150 }
  ];

  function populateWaistSelect() {
    var select = document.getElementById('sg-waist-select');
    if (!select) return;
    select.innerHTML = '';
    sizeData.forEach(function (row) {
      var opt = document.createElement('option');
      opt.value = row.in;
      opt.textContent = row.in + ' in';
      select.appendChild(opt);
    });
    updateBeltResult();
  }

  function populateBeltSelect() {
    var select = document.getElementById('sg-belt-select');
    if (!select) return;
    select.innerHTML = '';
    sizeData.forEach(function (row) {
      var opt = document.createElement('option');
      opt.value = row.cm;
      opt.textContent = row.in + ' in (' + row.cm + ' cm)';
      select.appendChild(opt);
    });
    updateWaistResult();
  }

  function updateBeltResult() {
    var select = document.getElementById('sg-waist-select');
    var result = document.getElementById('sg-belt-result');
    if (!select || !result) return;
    var row = sizeData.find(function (r) { return String(r.in) === select.value; });
    result.textContent = row ? row.in + ' in (' + row.cm + ' cm)' : '—';
  }

  function updateWaistResult() {
    var select = document.getElementById('sg-belt-select');
    var result = document.getElementById('sg-waist-result');
    if (!select || !result) return;
    var row = sizeData.find(function (r) { return String(r.cm) === select.value; });
    result.textContent = row ? row.in + ' in' : '—';
  }

  function initSizeGuide() {
    var modal = document.getElementById('size-guide-modal');
    if (!modal) return;

    modal.querySelectorAll('.sg-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        modal.querySelectorAll('.sg-tab').forEach(function (t) { t.classList.remove('sg-tab--active'); });
        modal.querySelectorAll('.sg-panel').forEach(function (p) { p.classList.remove('sg-panel--active'); });
        tab.classList.add('sg-tab--active');
        modal.querySelector('[data-panel="' + tab.dataset.tab + '"]').classList.add('sg-panel--active');
      });
    });

    var waistSelect = document.getElementById('sg-waist-select');
    var beltSelect = document.getElementById('sg-belt-select');
    if (waistSelect) waistSelect.addEventListener('change', updateBeltResult);
    if (beltSelect) beltSelect.addEventListener('change', updateWaistResult);

    populateWaistSelect();
    populateBeltSelect();

    modal.addEventListener('close', function () { document.body.style.overflow = ''; });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuide);
  } else {
    initSizeGuide();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
